export enum DateFormatEnum {
	DATE_FORMAT_1 = 'dd/MM/yyyy HH:mm',
	DATE_FORMAT_2 = 'dd/MM/yyyy HH:mm:ss',
	DATE_FORMAT_3 = 'yyyy/MM/dd HH:mm',
	DATE_FORMAT_4 = 'yyyy-MM-dd',
	DATE_FORMAT_5 = 'yyyy/MM/dd',
	DATE_FORMAT_6 = "yyyy-MM-dd'T'HH:mm:ss.SSSX",
	DATE_FORMAT_7 = "yyyy-MM-dd'T'HH:mm:ssXXX",
	DATE_FORMAT_8 = 'dd/MM/yyyy',
	DATE_FORMAT_9 = 'dd/MM/yyyy - HH:mm',
	DATE_FORMAT_10 = 'dd-MM-yyyy',
	DATE_FORMAT_11 = 'MMMM/yyyy',
	DATE_FORMAT_12 = 'yyyy-MM-dd HH:mm:ss.SSS',
	DATE_FORMAT_13 = 'HH:mm',
	DATE_FORMAT_14 = "yyyy-MM-dd'T'HH:mm:ss",
}
